import { Button, Modal, Trans } from '@/components'
import { CreditBreakdown } from '@/components/CreditBreakdown'
import { getBonusStat } from '@/models/credit'
import { useUserStore } from '@/stores/user'
import { formatPrice } from '@/utils/formatter'

interface BalanceDetailModalProps {
  onClose: () => void
  // omit to hide the recharge action (e.g. team members without recharge permission)
  onRecharge?: () => void
}

export function BalanceDetailModal({ onClose, onRecharge }: BalanceDetailModalProps) {
  const account = useUserStore((state) => state.account)
  const bonusStat = getBonusStat(account)

  return (
    <Modal open onClose={onClose}>
      <Modal.Header>
        <Trans ns="billing" i18nKey="balanceDetail.title">
          Balance (Credit) Detail
        </Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full flex items-center justify-between px-2 py-3">
          <div className="t-sb text-secondary">
            <Trans ns="billing" i18nKey="balanceDetail.availableBalance">
              Available Balance (Credit)
            </Trans>
          </div>
          <div className="t-sb text-primary">
            {formatPrice(account.totalBonus.moneyCent ?? 0, false, '')}
          </div>
        </div>
        {bonusStat && <CreditBreakdown bonusStat={bonusStat} size="md" />}
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" className="min-w-[88px]" onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        {onRecharge && (
          <Button type="secondary" className="min-w-[88px]" onClick={onRecharge}>
            <Trans ns="billing" i18nKey="rechargeBtn">
              Recharge
            </Trans>
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
